import type { OnyxTableNotFound } from '@onyx/angular';

export const CONTRACTORS_POINTS_OF_INTEREST_NOT_FOUND: OnyxTableNotFound = {
  icon: { name: 'menu-poi-filled', size: 32 },
  title: 'pointsOfInterest.empty.title',
  text: 'contractors.contractorForm.pointsOfInterest.empty.text',
};
